// extracted by mini-css-extract-plugin
module.exports = {"lg":"(min-width: 1024px)","header-title":"HeaderWithBackButton_header-title__Q0W3T"};